// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__34ssF","withMobileMargins":"DateRangeInput_withMobileMargins__94zOH","arrowIcon":"DateRangeInput_arrowIcon__1BAJo"};